module.exports = {"340422100":"寿春镇","340422101":"双桥镇","340422102":"涧沟镇","340422103":"丰庄镇","340422104":"正阳关镇","340422105":"迎河镇","340422106":"板桥镇","340422107":"安丰塘镇","340422108":"堰口镇","340422109":"保义镇","340422110":"隐贤镇","340422111":"安丰镇","340422112":"众兴镇","340422113":"茶庵镇","340422114":"三觉镇","340422115":"炎刘镇","340422116":"刘岗镇","340422117":"双庙集镇","340422118":"小甸镇","340422119":"瓦埠镇","340422120":"大顺镇","340422121":"窑口镇","340422200":"八公山乡","340422201":"张李乡","340422203":"陶店回族乡","340422402":"安徽寿县工业园区","340422500":"寿西湖农场","340422501":"正阳关农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340422.json
// module id = 985
// module chunks = 0